"use strict";
var appn;
(function (appn) {
    var fileUploadUtils;
    (function (fileUploadUtils) {
        function init() {
            $(document).on('input', '.fileinput input[type="file"]', function () {
                var _a;
                const file = this.files[0];
                if (file === undefined)
                    return;
                const container = $(this).closest(".fileinput").parent();
                const validationContainer = container.find("[data-valmsg-for]");
                const maxSize = (appn._MAXFILESIZE / 1024 / 1024).toString();
                const userSize = (Math.round(file.size / 1024 / 1024)).toString();
                const error = `<span for="${((_a = validationContainer.attr('data-valmsg-for')) === null || _a === void 0 ? void 0 : _a.replace('.', '_'))}" generated="true" class="">${(appn.strings.fileSizeMax.replace('{0}', maxSize).replace('{1}', userSize))}</span>`;
                validationContainer.html('');
                validationContainer.append(error);
                if (appn.utils.hasValue(file) && file.size > appn._MAXFILESIZE) {
                    validationContainer.removeClass('field-validation-valid');
                    validationContainer.addClass('input-validation-error');
                    $(this).val('');
                }
                else {
                    validationContainer.addClass('field-validation-valid');
                    validationContainer.removeClass('input-validation-error');
                }
            });
        }
        fileUploadUtils.init = init;
        function enableFileUploadControl($fileInputParentDiv) {
            $fileInputParentDiv.find('input').removeAttr('disabled');
            $fileInputParentDiv.find('.btn-file').removeAttr('disabled').removeClass('disabled');
            $fileInputParentDiv.find('.btn.iconReset').removeAttr('disabled');
            $fileInputParentDiv.find('.fileinput-new.thumbnail').css({ opacity: '1' });
        }
        fileUploadUtils.enableFileUploadControl = enableFileUploadControl;
        function disableFileUploadControl($fileInputParentDiv) {
            $fileInputParentDiv.find('input').attr('disabled', appn.emptyString);
            $fileInputParentDiv.find('.btn-file').attr('disabled', appn.emptyString).removeClass('disabled').addClass('disabled');
            $fileInputParentDiv.find('.btn.iconReset').attr('disabled', appn.emptyString);
            $fileInputParentDiv.find('.fileinput-new.thumbnail').css({ opacity: '0.2' });
        }
        fileUploadUtils.disableFileUploadControl = disableFileUploadControl;
        function fileUploadFailed(errorMessage) {
            appn.dialog.alert({
                modalColor: 'modal-danger',
                title: T('File Upload Failed'),
                message: errorMessage ? errorMessage : T('An unexpected error occurred while uploading your file.'),
                buttons: {
                    ok: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                autoHeaderIcon: false
            });
        }
        fileUploadUtils.fileUploadFailed = fileUploadFailed;
    })(fileUploadUtils = appn.fileUploadUtils || (appn.fileUploadUtils = {}));
})(appn || (appn = {}));
